import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageReviewComponent implements OnInit {
    public datasets: any[] = [];
    public filtered: any[] = [];
    public activeTab: string = 'review';
    public loading: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        let res = await wiz.call("list");
        if (res.code === 200) {
            this.datasets = res.data;
        } else {
            this.datasets = [];
        }
        this.applyFilter();
        this.loading = false;
    }

    public async switchTab(tab: string) {
        this.activeTab = tab;
        this.applyFilter();
        await this.service.render();
    }

    private applyFilter() {
        if (this.activeTab === 'review') {
            this.filtered = this.datasets.filter((d: any) => d.status === 'review' && d.user_status !== 'done');
        } else if (this.activeTab === 'done') {
            this.filtered = this.datasets.filter((d: any) => d.user_status === 'done' || d.status === 'completed');
        } else {
            this.filtered = this.datasets;
        }
    }

    public statusLabel(status: string, userStatus: string) {
        if (status === 'completed') return '마감';
        if (userStatus === 'done') return '검수 완료';
        if (status === 'review') return '검수중';
        if (status === 'generating') return '생성중';
        return '준비';
    }

    public statusColor(status: string, userStatus: string) {
        if (status === 'completed') return 'bg-zinc-100 text-zinc-500';
        if (userStatus === 'done') return 'bg-emerald-50 text-emerald-600';
        if (status === 'review') return 'bg-blue-50 text-blue-600';
        return 'bg-zinc-50 text-zinc-400';
    }

    public progressColor(progress: number) {
        if (progress >= 100) return 'bg-emerald-500';
        if (progress >= 50) return 'bg-blue-500';
        return 'bg-amber-500';
    }

    public typeLabel(type: string): string {
        return type === 'instruction' ? 'Instruction' : 'Fine Tuning';
    }

    public typeColor(type: string): string {
        return type === 'instruction' ? 'bg-violet-50 text-violet-600' : 'bg-sky-50 text-sky-600';
    }

    public navigateTo(id: string) {
        this.service.href('/review/' + id);
    }

    public tabCount(tab: string) {
        if (tab === 'review') {
            return this.datasets.filter((d: any) => d.status === 'review' && d.user_status !== 'done').length;
        } else if (tab === 'done') {
            return this.datasets.filter((d: any) => d.user_status === 'done' || d.status === 'completed').length;
        }
        return this.datasets.length;
    }
}

export default PageReviewComponent;